import { MapContainer, TileLayer, Marker, Polyline, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

const pin = (color, size = 16) => L.divIcon({ className: "velocity-pin", iconSize: [size, size], iconAnchor: [size / 2, size / 2], html: `<div style="width:${size}px;height:${size}px;border-radius:50%;background:${color};box-shadow:0 0 0 3px rgba(11,13,18,.9),0 0 12px ${color}"></div>` });
const PICK = pin("#22d3ee"), DROP = pin("#64748b", 10), BASE = pin("#f59e0b", 18);
const usd = (v) => `$${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

function Fit({ pts }) {
  const map = useMap();
  useEffect(() => { if (pts.length) map.fitBounds(L.latLngBounds(pts).pad(0.2), { maxZoom: 7 }); }, [pts.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export const LoadBoardMap = ({ loads, base, selected, onSelect }) => {
  const withCoords = loads.filter((l) => l.pickup_lat != null && l.dropoff_lat != null);
  const pts = withCoords.flatMap((l) => [[l.pickup_lat, l.pickup_lng], [l.dropoff_lat, l.dropoff_lng]]);
  if (base) pts.push([base.lat, base.lng]);
  return (
    <div className="rounded-2xl overflow-hidden border border-slate-800 h-[420px] relative" data-testid="load-board-map">
      <MapContainer center={[37.8, -96]} zoom={4} className="h-full w-full" scrollWheelZoom>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" className="map-dark-tiles" />
        <Fit pts={pts.length ? pts : [[24.5, -125], [49.5, -66]]} />
        {base && <Marker position={[base.lat, base.lng]} icon={BASE}><Tooltip>Your base{base.radius ? ` · ${base.radius} mi lane` : " · nationwide"}</Tooltip></Marker>}
        {withCoords.map((l) => {
          const sel = selected === l.load_id;
          return (
            <span key={l.load_id}>
              <Polyline positions={[[l.pickup_lat, l.pickup_lng], [l.dropoff_lat, l.dropoff_lng]]} pathOptions={{ color: sel ? "#22d3ee" : "#22d3ee", weight: sel ? 3 : 1.5, opacity: sel ? 0.95 : 0.35, dashArray: sel ? null : "4 6" }} />
              <Marker position={[l.dropoff_lat, l.dropoff_lng]} icon={DROP} />
              <Marker position={[l.pickup_lat, l.pickup_lng]} icon={PICK} eventHandlers={{ click: () => onSelect?.(l.load_id) }}>
                <Tooltip><div style={{ fontFamily: "Inter, sans-serif", fontSize: 12 }}><b>{usd(l.price)}</b> · {l.vehicles.length} veh · {l.distance_miles ? `${l.distance_miles} mi` : ""}<br />{l.pickup_address} → {l.dropoff_address}</div></Tooltip>
              </Marker>
            </span>
          );
        })}
      </MapContainer>
      <div className="absolute bottom-3 left-3 z-[400] px-2.5 py-1.5 rounded-lg bg-[#0B0D12]/90 border border-slate-800 text-[10px] font-mono text-slate-400 flex gap-3"><span><span className="inline-block w-2 h-2 rounded-full bg-cyan-400 mr-1" />pickup</span><span><span className="inline-block w-2 h-2 rounded-full bg-slate-500 mr-1" />delivery</span>{base && <span><span className="inline-block w-2 h-2 rounded-full bg-amber-400 mr-1" />your base</span>}<span>{withCoords.length} open loads</span></div>
    </div>
  );
};
